import React, { useState } from 'react';

type SearchFieldRowProps = {
    initialSearch?: string;
    header: string;
    label: string;
    buttonText: string;
    searchParameter?: string;
    onKeywordChange?: (keyword: string) => void;
    onFormSubmit?: (keyword: string) => void;
};

const SearchFieldRow: React.FC<SearchFieldRowProps> = ({ initialSearch, header, label, buttonText, onKeywordChange, onFormSubmit, searchParameter = "search" }) => {

    const [searchValue, setSearchValue] = useState(initialSearch || '');

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value);
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        // if there's onFormSubmit, call it but don't call anything else
        if (onFormSubmit) {
            onFormSubmit(searchValue);
            return;
        }

        // check onKeywordChange, if exists call it
        if (onKeywordChange) {
            onKeywordChange(searchValue);
        }

        // Add search parameter to URL
        const url = new URL(window.location.href);

        const params = new URLSearchParams(url.search);

        if (searchValue) {
            params.set(searchParameter, searchValue);
        } else {
            params.delete(searchParameter);
        }

        // set location
        url.search = params.toString();

        window.history.replaceState({}, '', url.toString());

    }

    const handleClearFilters = () => {

        setSearchValue('');

        // check onKeywordChange, if exists call it
        if (onKeywordChange) {
            onKeywordChange('');
        }

        // Add search parameter to URL
        const url = new URL(window.location.href);

        const params = new URLSearchParams(url.search);

        params.delete(searchParameter);

        // set location
        url.search = params.toString();

        window.history.replaceState({}, '', url.toString());
    };

    return (
        <div className="pattern">
            <div className="container container--md">
                <h2 className="h1">{header}</h2>
                <form onSubmit={handleFormSubmit}>
                    <div className="search-fields">
                        <label className="screen-reader-text" htmlFor="search">{label}</label>
                        <input type="text" id="search" name="keyword" value={searchValue} onChange={handleInputChange} />
                        <button type="submit" className="btn-primary"><span>{buttonText}</span></button>
                    </div>
                    {initialSearch && <button className="tiny-text btn-text-link search-fields-clear" onClick={handleClearFilters}>Clear Search</button>}
                </form>
            </div>
        </div>
    );
};

export default SearchFieldRow;